import { Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AbstractComponent } from '../../abstract-component';

@Component({
  selector: 'app-typescript',
  imports: [FormsModule],
  templateUrl: './typescript.component.html',
  styleUrl: './typescript.component.css',
})
export class TypescriptComponent extends AbstractComponent {
respuesta = signal('');
titulo = '';
texto = '';
estadoNotificacion = signal('');
enviandoNotificacion = signal(false);

notificar() {
  const titulo = this.titulo.trim();
  const texto = this.texto.trim();
  if (!titulo || !texto || this.enviandoNotificacion()) return;

  this.estadoNotificacion.set('');
  this.enviandoNotificacion.set(true);
  this.typescriptService.notificar(titulo, texto).subscribe({
    next: (res) => this.estadoNotificacion.set(res.mensaje),
    error: () => {
      this.estadoNotificacion.set('Error al enviar la notificación');
      this.enviandoNotificacion.set(false);
    },
    complete: () => this.enviandoNotificacion.set(false),
  });
}

consultarBackend() {
  this.typescriptService.hello().subscribe({
    next: (res) => {
      this.respuesta.set(JSON.stringify(res, null, 2));
      console.log('Response received:', this.respuesta());
    },
    error: (err) => {
      console.error(err);
      this.respuesta.set('Error al consultar el backend');
    },
    complete: () => {
      console.log('Request completed');
    }
  });
}

}
